import classNames from 'classnames/bind';
import styles from './DeletionFiles.module.css';
import {
  DATE,
  FILE,
  FILES_SCHEDULED_DELETION,
  FILE_SIZE,
  SCHEDULED_DELETION_DATE,
} from '../../../../constants';
import useSimpleBar from '../../../../hooks/useSimpleBar';
import SimpleBar from 'simplebar-react';
import { useGetStorageRemovalListQuery } from '../../../../services/membership';
import { formatBytes } from '../../../../utils/util';
import { formatDate } from '../../../../utils/date';

export default function DeletionFiles() {
  const cx = classNames.bind(styles);
  const [simplebarRef] = useSimpleBar();

  const { data, isLoading } = useGetStorageRemovalListQuery();

  if (isLoading || !data) return null;

  const { removeDate, storageList } = data;
  const headList = [DATE, FILE, FILE_SIZE];

  return (
    <>
      <div className={cx('content')}>
        <p className={cx('desc')}>
          <span
            dangerouslySetInnerHTML={{ __html: FILES_SCHEDULED_DELETION }}
          ></span>
        </p>
        <p className={cx('desc')}>
          {SCHEDULED_DELETION_DATE} : <span>{formatDate(removeDate)}</span>
        </p>
        <SimpleBar forceVisible={true} ref={simplebarRef}>
          <div className={cx('table_list', 'table_head', 'drive_head')}>
            {headList.map((head) => (
              <div key={head} className={cx('items')}>
                {head}
              </div>
            ))}
          </div>
          <div className={cx('table_list', 'table_body', 'drive_body')}>
            {storageList.map(({ regDate, title, location, size }, i) => (
              <div key={i} className={cx('items')}>
                <span className={cx('sub')}>
                  <span>{formatDate(regDate)}</span>
                </span>
                <span className={cx('sub')}>
                  <span className={cx('name', 'text_clip')}>{title}</span>
                  <span className={cx('location', 'text_clip')}>
                    {location}
                  </span>
                </span>
                <span className={cx('sub')}>
                  <span className={cx('size', 'text_clip')}>
                    {formatBytes(size)}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </SimpleBar>

        {/*         <div className={cx('btn_wrap')}>
          <button type="button" className={cx('btn', 'b_t')}>
            <span>{CONFIRM}</span>
          </button>
        </div> */}
      </div>
    </>
  );
}
